import React from 'react';
import Card from '@/components/UI/Card';
import { NoRecordIcon } from './SvgIcons';

interface DetailItem {
  label: string;
  value: string | number | undefined | null;
  render?: () => React.ReactNode;
}

interface DetailsCardProps {
  title?: string | undefined;
  userName?: string | undefined;
  details: DetailItem[];
  columns?: number;
  customerSince?: string;
  emptyMessage?: string;
}

const DetailsCard: React.FC<DetailsCardProps> = ({
  title,
  userName,
  details,
  columns = 2,
  customerSince,
  emptyMessage,
}) => {
  return (
    <Card>
      <div className="flex justify-between">
        {title && <h3 className="text-base text-black mb-5">{title}</h3>}
        {userName && <h3 className="text-3xl text-black mb-5">{userName}</h3>}
        {customerSince ? (
          <div className="text-sm text-gray-300">{customerSince}</div>
        ) : (
          ''
        )}
      </div>
      <div
        className={`grid grid-cols-1 sm:grid-cols-${columns} text-sm gap-x-4 gap-y-5`}
      >
        {details.length === 0 ? (
          <div className="flex flex-col justify-center items-center col-span-2 text-sm text-center text-gray-500">
            <NoRecordIcon className="w-12! h-12!" />
            <span className="mt-2 mb-3">{emptyMessage}</span>
          </div>
        ) : (
          details.map((item, index) => (
            <div key={index} className="text-sm text-gray-300">
              <h5 className="font-medium mb-2 text-black">{item.label}:</h5>

              {item.render ? item.render() : item.value || '--'}
            </div>
          ))
        )}
      </div>
    </Card>
  );
};

export default DetailsCard;
